module.exports = __webpack_public_path__ + "img/artist-and-celeb.3bf810bd.png";